import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { COLLECTIONS, parseBrandRoute } from '@brands/shared';
import { useAuth } from '../auth/AuthContext';
import { Loading } from '../components/Loading';
import { firebase } from '../lib/firebase';
import { BrandPortalPage } from './BrandPortalPage';
import { CampaignPage } from './CampaignPage';
import { NotFoundPage } from './NotFoundPage';

function CampaignBySlug({ brandSlug, slug }: { brandSlug: string; slug: string }) {
  const { session } = useAuth();
  const key = `${brandSlug}/${slug}`;
  const [resolved, setResolved] = useState<{ key: string; id: string | null } | null>(null);

  useEffect(() => {
    if (!session) return;
    let alive = true;
    const base = collection(firebase().db, COLLECTIONS.campaigns);
    const filters = [where('clientSlug', '==', brandSlug), where('slug', '==', slug)];
    // El cliente solo puede consultar campañas publicadas a las que tiene acceso (reglas).
    const q = session.isStaff
      ? query(base, ...filters, limit(1))
      : query(
          base,
          ...filters,
          where('memberEmails', 'array-contains', session.email),
          where('status', '==', 'published'),
          limit(1),
        );
    getDocs(q).then(
      (snap) => alive && setResolved({ key, id: snap.docs[0]?.id ?? null }),
      () => alive && setResolved({ key, id: null }),
    );
    return () => {
      alive = false;
    };
  }, [key, brandSlug, slug, session]);

  if (!resolved || resolved.key !== key) return <Loading />;
  if (!resolved.id) return <NotFoundPage />;
  return <CampaignPage campaignId={resolved.id} />;
}

/** Portal de marca o campaña según host + ruta ({marca}.brands.mx/… o /{marca}/…). */
export function BrandRoutePage() {
  const location = useLocation();
  const route = parseBrandRoute(window.location.host, location.pathname);
  if (!route) return <NotFoundPage />;
  if (route.campaignSlug)
    return <CampaignBySlug brandSlug={route.brandSlug} slug={route.campaignSlug} />;
  return <BrandPortalPage brandSlug={route.brandSlug} />;
}
